import axios from 'axios';
import { AccumulatorDetailList } from '../../interfaces/Accumulator';
import { DateRangeEnum } from '../Pickers/dataRange';
import { selectedDateRangeRest } from '../Pickers/dataRange';


export type RangeParams = {
    isOpen: boolean;
    range: DateRangeEnum
}


export type ACBRangedListParams = {
    period: 'quartal' | 'month' | 'week' | 'today';
    building: {
        timeout?: NodeJS.Timeout;
        isOpen: boolean;
        value?:string | null;
    };
    client_device_type: {
        timeout?: NodeJS.Timeout;
        isOpen: boolean;
        value?:string | null;
    };
    search?: string;
    ordering?: string;
    limit:number;
    offset:number;
    currentPage: number;
    timeout: NodeJS.Timeout | undefined;
    dateRange: RangeParams;
    organization?: string;
}

export interface ACBRangedListResponse {
    count: number;
    next: string | null; // Assuming "next" can be null if there are no more pages
    previous: string | null; // Assuming "previous" can be null if there is no previous page
    results: AcbRangedListResult[] | undefined;
}

export interface DeviceListResponse {
    count: number;
    next: string | null; // Assuming "next" can be null if there are no more pages
    previous: string | null; // Assuming "previous" can be null if there is no previous page
    results: any[] | undefined;
}

export interface AcbRangedListResult {
    id: number;
    serial_number: string;
    custom_name: string;
    organization_name: string;
    building_name: string;
    client_device_type: string;
    error_count: number;
    manufacture_date: string; // ISO date string
    soh: number;
    energy_ratio: number;
    cycles: number;
    online_dt: string; // ISO date string
    energy_charge: number;
    activity_time_delta: number;
    total_time_delta: number;
    activity_ratio: number;
}


// TODO transfer filters
function generateQueryString(params: any): string {
    const queryString = Object.entries(params)
        .filter(([key, value]) => value !== undefined) // filter out undefined values
        .map(([key, value]) => {
            if (key === 'offset' && params.limit && params.currentPage) {
                value = (params.currentPage - 1) * params.limit
            }
            if (key === 'currentPage') {
                return null
            }

            if (key === 'dateRange') {
                key = 'period'
                value = selectedDateRangeRest(params.dateRange.range)
            }
            
            if (key === 'building') {
                key = 'building'
                value = params.building?.value !== undefined 
                    ? params.building.value 
                    : 'undefined'
            }

            if (key === 'client_device_type') {
                key = 'client_device_type'
                value = params.client_device_type?.value  !== undefined 
                    ? params.client_device_type.value 
                    : 'undefined'
            }

            return `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`;
        })
        .join('&'); // Join the key-value pairs with '&'

    return queryString ? `?${queryString}` : '';
}


export const ClientFetchACBRangedList = async (setAcbList: (value: ACBRangedListResponse) => void, params: ACBRangedListParams) => {
    axios.get<ACBRangedListResponse>(`${process.env.REACT_APP_DJANGO_SERVER_URL}/api/client/v1/acb/ranged-list${generateQueryString(params)}`,
        { withCredentials: true }
    )
    .then(response => {
        if (response.status === 200) {
            var details: ACBRangedListResponse = response.data
            setAcbList(details)
        }
    })
    .catch(error => {
        console.error('Error fetching accumulator details:', error);
        // window.location = `/error/${error.status}`
        // Handle the error accordingly redirect to somewhere else
    });
}


export const AxiosFetchGrpDevice = async (role: string, set: (value: any) => void, params: ACBRangedListParams) => {
    axios.get<DeviceListResponse>(`${process.env.REACT_APP_DJANGO_SERVER_URL}/api/${role}/v1/device_list${generateQueryString(params)}`,
        { withCredentials: true }
    )
    .then(response => {
        if (response.status === 200) {
            var details: DeviceListResponse = response.data
            set(details)
        }
    })
    .catch(error => {
        console.error('Error fetching accumulator details:', error);
    });
}

export const AxiosFetchGrpBuildings = async (role: string, set: (value: any) => void, params: ACBRangedListParams) => {
    axios.get<DeviceListResponse>(`${process.env.REACT_APP_DJANGO_SERVER_URL}/api/${role}/v1/building_list${generateQueryString(params)}`,
        { withCredentials: true }
    )
    .then(response => {
        if (response.status === 200) {
            var details: DeviceListResponse = response.data
            set(details)
        }
    })
    .catch(error => {
        console.error('Error fetching accumulator details:', error);
    });
}


export const StaffFetchACBRangedList = async (
    setAcbList: (value: ACBRangedListResponse) => void, 
    params: ACBRangedListParams
) => {
    axios.get<ACBRangedListResponse>(`${process.env.REACT_APP_DJANGO_SERVER_URL}/api/staff/v1/acb/ranged-list${generateQueryString(params)}`,
        { withCredentials: true }
    )
    .then(response => {
        if (response.status === 200) {
            var details:ACBRangedListResponse = response.data
            setAcbList(details)
        }
    })
    .catch(error => {
        console.error('Error fetching accumulator details:', error);
    });
}


export const StaffFetchACBList = async (setAcbList: (value: AccumulatorDetailList) => void) => {
    axios.get<AccumulatorDetailList>(`${process.env.REACT_APP_DJANGO_SERVER_URL}api/client/v1/acb/ranged-list`,
        { withCredentials: true }
    )
    .then(response => {
        if (response.status === 200) {
            var details:AccumulatorDetailList = response.data
            setAcbList(details)
        }
    })
    .catch(error => {
        console.error('Error fetching accumulator details:', error);
        // window.location = `/error/${error.status}`
        // Handle the error accordingly redirect to somewhere else
    });
}